/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import ContextProvider from './Context';
import App from './App';

import "bootstrap-icons/font/bootstrap-icons.css";
import "./styles/scss/style.scss";
import "./styles/css/style.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ContextProvider>
      <App />
    </ContextProvider>
  </React.StrictMode>
);
